export interface PixelCrop {
  x: number;
  y: number;
  width: number;
  height: number;
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('Failed to load image for cropping'));
    img.src = src;
  });
}

/**
 * Crop a region of an image (given a same-origin URL, e.g. a blob: URL) and
 * return it as a File. Source must be same-origin/blob so the canvas is not
 * tainted and toBlob() succeeds.
 */
export async function cropImageToFile(
  imageSrc: string,
  crop: PixelCrop,
  fileName: string,
  mimeType = 'image/png',
): Promise<File> {
  const img = await loadImage(imageSrc);
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(crop.width));
  canvas.height = Math.max(1, Math.round(crop.height));
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Could not get canvas context');
  ctx.drawImage(
    img,
    crop.x, crop.y, crop.width, crop.height,
    0, 0, crop.width, crop.height,
  );
  const blob: Blob = await new Promise((resolve, reject) => {
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error('Canvas is empty'))),
      mimeType,
      0.92,
    );
  });
  return new File([blob], fileName, { type: mimeType });
}
